import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListClientComponent } from './list-admins/list-client.component';
import { ClientRoutingModule } from './client-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ClientFormComponent } from './admins-form/client-form.component';
import { ListOrganizersComponent } from './list-clients/list-organizers.component';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { LandingPageListComponent } from './landing-page-list/landing-page-list.component';
import { TranslateModule, TranslateStore } from '@ngx-translate/core';
import { ParticipantService } from '../shared/services/participant.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Enregistrer les données de locale français
registerLocaleData(localeFr);

@NgModule({
    declarations: [
        ListClientComponent, 
        ClientFormComponent,  
        LandingPageListComponent,
        ListOrganizersComponent
    ],
    imports: [
        CommonModule,
        ClientRoutingModule,
        SharedModule,
        FormsModule,
        DataTablesModule,
        TranslateModule,
        ClientRoutingModule,
    ],
    providers: [
        TranslateStore,
        ParticipantService,
        { provide: LOCALE_ID, useValue: 'fr-FR' } // Ajout du provider pour le locale français
    ],
})
export class ClientModule {
}